import { NavDropdown, Image, Badge } from 'react-bootstrap'
import { FaBell } from "react-icons/fa";
import { useRouter } from 'next/router'
import navStyles from './topnav.module.css'
import TimeDiff from './TimeDiff';
import params from '../data/params'

function Notification(props) {
    
    const notifications = props.notification;
    const badgeCounter = notifications ? notifications.length : 0;


    return (
        <NavDropdown alignRight title={
                    <div>
                        <FaBell className="text-white" size="23"/>
                        <Badge variant={(props.origin === "wellness")  ? "success" : "primary"}  className={`position-relative ${navStyles.notification}`}>
                            {badgeCounter}
                        </Badge>
                    </div>
                }>
        {
            badgeCounter > 0 ?  
            
                notifications && notifications.map((data,idx) => {
                    const theObject = data.remarks ? JSON.parse(data.remarks) : '';
                    const thumbnail =  theObject && theObject.thumbnail ? theObject.thumbnail : ''

                    let image = "";

                    if (typeof thumbnail !== "undefined") {
                        const image_url = thumbnail.split('?');
                        image  = image_url[0];
                    }


                    return (
                        <div key={idx} className={`d-flex align-items-start p-2 ${navStyles.notiflist}`}>
                            <Image src={image ? image : (data.notification_id == 35 ? params.defaultImage : params.noimage)} width="100"/>
                            <div className="ml-3 h7">
                                <p className="mb-0">{data.title}</p>
                                <div dangerouslySetInnerHTML={{ __html: data.content }} />
                                <TimeDiff startdate={data.created_at} />
                            </div>
                        </div>
                    );
                })

            :

            <div className={`d-flex align-items-start p-2 ${navStyles.notiflist}`}>
                <div className="text-center">
                    <p className="mb-0">No Notifications</p>
                </div>
            </div>
            
        }

        { <style jsx global>{`
            @media(max-width:767px){
                .topnav_notiflist__3azq3 img{
                    width:100px!important;
                }
            }

            .dropdown-menu-right{
                overflow-y: scroll;
            }
        `}</style> }
        </NavDropdown>
    )
}

export default Notification
